export const TOGGLE_ALERT = 'TOGGLE_ALERT'



/** WEBPACK FOOTER **
 ** ./src/containers/Alert/modules/constants.js
 **/